import styled, { css } from 'styled-components';
import { border, color, layout, space } from 'styled-system';

import ButtonStyles from '../base/buttonStyles';

const LayoutAsideStyles = styled.aside`
  width: 20rem;
  flex-shrink: 0;

  @media screen and (max-width: 1023px) {
    width: auto;
  }
`;

const LayoutContentStyles = styled.main`
  flex-grow: 1;

  ${props =>
    props.centeredContent &&
    css`
      align-items: center;
      display: flex;
    `};
`;

const LayoutStyles = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
`;

const LayoutMainStyles = styled.div`
  ${space}

  position: relative;
  flex-grow: 1;
  overflow: hidden;
  overflow-y: auto;
`;

const LayoutContainerStyles = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;

  ${props =>
    props.noPadding === true
      ? css`
          padding: 0;
          height: 100%;
          display: flex;
        `
      : css`
          padding-left: ${props.theme.space[3]};
          padding-right: ${props.theme.space[3]};
        `}

  ${props =>
    props.noPadding === false &&
    css`
      margin-top: ${props.theme.space[3]};
      margin-bottom: ${props.theme.space[3]};
    `};

  @media screen and (max-width: 1023px) {
    ${props =>
      props.noPadding === false &&
      css`
        margin-top: ${props.theme.space[2]};
        margin-bottom: ${props.theme.space[2]};
      `};
  }

  ${props =>
    props.wide === true &&
    css`
      max-width: 1278px;
    `}

  ${props =>
    props.narrow === true &&
    css`
      max-width: 660px;
    `}

  ${props =>
    props.ltr === true &&
    css`
      display: flex;
      @media screen and (max-width: 1023px) {
        display: block;

        ${LayoutAsideStyles} {
          margin-bottom: ${props.theme.space[2]};
        }
      }

      ${LayoutAsideStyles} {
        margin-right: ${props.theme.space[3]};
        @media screen and (max-width: 1023px) {
          margin-right: 0;
        }
      }

      ${LayoutContentStyles} {
        margin-right: 0;
        @media screen and (max-width: 1023px) {
          margin-right: 0;
        }
      }
    `};

  ${props =>
    props.ltr === false &&
    css`
      display: flex;
      flex-direction: row-reverse;

      @media screen and (max-width: 1023px) {
        display: block;
      }

      ${LayoutContentStyles},
      ${LayoutAsideStyles} {
        margin-left: 0;

        @media screen and (max-width: 1023px) {
          margin-left: 0;
        }
      }
    `};

  ${space}
  ${layout}
`;

const LayoutHeaderStyles = styled.header`
  background-color: ${props => props.theme.colors.bodyBackground};
  border-bottom: ${props => props.theme.colors.separator};
  padding: ${props => props.theme.space[3]} 0;
  box-shadow: ${props => props.theme.boxShadow};
  z-index: 15;

  ${ButtonStyles} {
    height: auto;
    min-height: ${props => props.theme.buttonSize.normal};
  }
`;

const LayoutFooterStyles = styled.footer`
  background-color: ${props => props.theme.colors.bodyBackground};
  border-bottom: ${props => props.theme.colors.separator};
  padding: ${props => props.theme.space[3]} 0;
  box-shadow: ${props => props.theme.boxShadow};
  z-index: 10;

  // ${ButtonStyles} {
  //   height: auto;
  //   min-height: ${props => props.theme.buttonSize.normal};
  // }
`;

const LayoutHeaderTitleStyles = styled.span`
  ${border}
  ${color}
  ${layout}

  display: flex;
  align-items: center;
  border-width: 0.0625rem;
  border-style: solid;
  font-weight: bold;
  padding: 0 ${props => props.theme.space[2]};
  min-height: ${props => props.theme.buttonSize.normal};
  white-space: nowrap;

  ${props =>
    props.borderColor === undefined &&
    css`
      border-color: ${props.theme.colors.inputBorder};
    `};
`;

const LayoutHeaderLeftStyles = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 1;
  flex-grow: 0;
  padding-right: ${props => props.theme.space[3]};
`;

const LayoutHeaderRightStyles = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: end;
`;

LayoutStyles.MainStyles = LayoutMainStyles;
LayoutStyles.ContainerStyles = LayoutContainerStyles;
LayoutStyles.HeaderStyles = LayoutHeaderStyles;
LayoutStyles.FooterStyles = LayoutFooterStyles;
LayoutStyles.HeaderTitleStyles = LayoutHeaderTitleStyles;
LayoutStyles.HeaderLeftStyles = LayoutHeaderLeftStyles;
LayoutStyles.HeaderRightStyles = LayoutHeaderRightStyles;
LayoutStyles.AsideStyles = LayoutAsideStyles;
LayoutStyles.ContentStyles = LayoutContentStyles;

export default LayoutStyles;
